import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";

export interface EmitterOptions {
    uuid?: string,
    value?: string|number|string[], 
    refresh?: number
    is_deleted? :number
}

@Injectable({
    providedIn: 'root'
})

export class DocumentFieldEmitterService {
    private data = new BehaviorSubject<EmitterOptions>({});


    /**
     * Patch data in behavior subject
     * @param data 
     */
    patchData(data: EmitterOptions){
        this.data.next(data);
    }


    /**
     * Get patched data
     * @returns observable
     */
    getData(): Observable<EmitterOptions>{
        return this.data.asObservable();
    }
}
